export const academicDisciplines = [
  {
    id: 1,
    customerName: "Anthropology",
  },
  {
    id: 2,
    customerName: "Geography",
  },
  {
    id: 3,
    customerName: "History",
  },
  {
    id: 4,
    customerName: "Interdisciplinary studies",
  },
  {
    id: 5,
    customerName: "Linguistics and languages",
  },
  {
    id: 6,
    customerName: "Philosophy",
  },
  {
    id: 7,
    customerName: "Political science",
  },
  {
    id: 8,
    customerName: "Psychology",
  },
  {
    id: 9,
    customerName: "Religion",
  },
  {
    id: 10,
    customerName: "Sociology",
  },
  {
    id: 11,
    customerName: "The arts",
  },
  {
    id: 12,
    customerName: "Biology",
  },
  {
    id: 13,
    customerName: "Chemistry",
  },
  {
    id: 14,
    customerName: "Earth sciences",
  },
  {
    id: 15,
    customerName: "Physics",
  },
  {
    id: 16,
    customerName: "Space sciences",
  },
  {
    id: 17,
    customerName: "Computer sciences",
  },
  {
    id: 18,
    customerName: "Logic",
  },
  {
    id: 19,
    customerName: "Mathematics",
  },
  {
    id: 20,
    customerName: "Systems science",
  },
  {
    id: 21,
    customerName: "Agriculture",
  },
  {
    id: 22,
    customerName: "Architecture and design",
  },
  {
    id: 23,
    customerName: "Business",
  },
  {
    id: 24,
    customerName: "Divinity",
  },
  {
    id: 25,
    customerName: "Economics",
  },
  {
    id: 26,
    customerName: "Education",
  },
  {
    id: 27,
    customerName: "Engineering and technology",
  },
  {
    id: 28,
    customerName: "Environmental studies and forestry",
  },
  {
    id: 29,
    customerName: "Family and consumer science",
  },
  {
    id: 30,
    customerName: "Human physical performance and recreation",
  },
  {
    id: 31,
    customerName: "Journalism, media studies and communication",
  },
  {
    id: 32,
    customerName: "Law",
  },
  {
    id: 33,
    customerName: "Library and museum studies",
  },
  {
    id: 34,
    customerName: "Medicine",
  },
  {
    id: 35,
    customerName: "Military sciences",
  },
  {
    id: 36,
    customerName: "Public administration",
  },
  {
    id: 37,
    customerName: "Social work",
  },
  {
    id: 38,
    customerName: "Transportation",
  },
  {
    id: 39,
    customerName: "Archaeology",
  },
  {
    id: 40,
    customerName: "Area studies",
  },
  {
    id: 41,
    customerName: "Ethnic and cultural studies",
  },
  {
    id: 42,
    customerName: "Gender and sexuality studies",
  },
  {
    id: 43,
    customerName: "Organizational studies",
  },
  {
    id: 44,
    customerName: "English",
  },
  {
    id: 45,
    customerName: "Ethics",
  },
  {
    id: 46,
    customerName: "International relations",
  },
  {
    id: 47,
    customerName: "Sociology of terrorism",
  },
  {
    id: 48,
    customerName: "Culinary arts",
  },
  {
    id: 49,
    customerName: "Literature",
  },
  {
    id: 50,
    customerName: "Performing arts",
  },
  {
    id: 51,
    customerName: "Visual arts",
  },
  {
    id: 52,
    customerName: "Microbiology",
  },
  {
    id: 53,
    customerName: "Astronomy",
  },
  {
    id: 54,
    customerName: "Information science",
  },
  {
    id: 55,
    customerName: "Programming",
  },
  {
    id: 56,
    customerName: "Applied mathematics",
  },
  {
    id: 57,
    customerName: "Pure mathematics",
  },
  {
    id: 58,
    customerName: "Management (Business)",
  },
  {
    id: 59,
    customerName: "Finance",
  },
  {
    id: 60,
    customerName: "Accounting and banking",
  },
  {
    id: 61,
    customerName: "E-commerce",
  },
  {
    id: 62,
    customerName: "Marketing",
  },
  {
    id: 63,
    customerName: "Theology",
  },
  {
    id: 64,
    customerName: "Macroeconomics",
  },
  {
    id: 65,
    customerName: "Microeconomics",
  },
  {
    id: 66,
    customerName: "Leadership (Education)",
  },
  {
    id: 67,
    customerName: "Aviation",
  },
  {
    id: 68,
    customerName: "Sports",
  },
  {
    id: 69,
    customerName: "Communication studies",
  },
  {
    id: 70,
    customerName: "International Law",
  },
  {
    id: 71,
    customerName: "Criminal Justice",
  },
  {
    id: 72,
    customerName: "Healthcare and nursing",
  },
  {
    id: 73,
    customerName: "Leadership (Military sciences)",
  },
  {
    id: 74,
    customerName: "Public policy",
  },
  {
    id: 75,
    customerName: "Government studies",
  },
  {
    id: 76,
    customerName: "Emergency management",
  },
  {
    id: 77,
    customerName: "Logistics (Transportation)",
  },
  {
    id: 78,
    customerName: "Human resources management (HRM)",
  },
  {
    id: 79,
    customerName: "Career development",
  },
  {
    id: 80,
    customerName: "Creative writing",
  },
  {
    id: 81,
    customerName: "Music",
  },
  {
    id: 82,
    customerName: "Film studies",
  },
  {
    id: 83,
    customerName: "Information technology",
  },
  {
    id: 84,
    customerName: "Statistics",
  },
  {
    id: 85,
    customerName: "Public relations",
  },
];
